import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

if (process?.env?.NODE_ENV === 'production') {
  Bugsnag.start({
    apiKey: process.env.BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginReact(React)],
    appVersion: process.env.VERSION_SHA,
    releaseStage: process.env.PL_ENV,
  });
}

export default Bugsnag;
